import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'

const ClearAgreementSignListConfirmationModalUI = ({
  context,
  isOpen,
  onCancel,
  onConfirm,
  submitted,
  successMsg,
  errorList,
  setErrorList
}) => (
  <ModalFormUI
    context={context}
    titleLabel='Confirm reset'
    buttonLabel='Reset agreement sign list'
    cancelLabel='Cancel'
    isOpen={isOpen}
    onRequestClose={onCancel}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onConfirm}
    busy={submitted}
  >
    <p className='g_m_top_25'>
      This will clear the agreement sign list and remove all document signing progress for this loan, returning it to the state before documents were set up for signing. This action cannot be undone.
    </p>
  </ModalFormUI>
)

export default ClearAgreementSignListConfirmationModalUI
